import { ReactNode } from 'react';
import {
  HelperText,
  Label
} from '@/common/PassengerTools/PassengerTools.styles';

type FormFieldProps = {
  label: string;
  htmlFor: string;
  helperText?: string;
  children: ReactNode;
};

export default function FormField({
  label,
  htmlFor,
  helperText,
  children
}: FormFieldProps) {
  return (
    <div>
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {helperText && <HelperText>{helperText}</HelperText>}
    </div>
  );
}
